import { APIConfiguration } from '@savgroup-front-common/configuration';

export const ORDER_URL = {
  GET_ORDER_BY_REFERENCE: `${APIConfiguration.owner}orders/search`,
  GET_ORDER_DETAILS_BY_RECEIPT_INFORMATION: `${APIConfiguration.owner}orders/salesReceipt`,
};
